export const generatePublicLink = async (
  serialNo?: string,
  transactionNo?: string
): Promise<string> => {
  const baseUrl = 'https://www.pcworth.com/pc-worth-cares';
  const params = new URLSearchParams();

  if (serialNo) {
    params.append('sn', serialNo);
  }

  if (transactionNo) {
    params.append('tn', transactionNo);
  }

  const queryString = params.toString();
  const generatedURL = queryString ? `${baseUrl}?${queryString}` : baseUrl;

  try {
    await navigator.clipboard.writeText(generatedURL);
  } catch (error) {
    console.error('Failed to copy link to clipboard:', error);
  }

  return generatedURL;
};

export const transformEcommQuotationLink = (link: string): string => {
  if (!link) return "";

  return link
    .replace("/user-cart", "/qt")
    .replace("qid=", "q=")
    .replace("override=", "ov=")
    .replace("branch_id=", "bid=");
};